import { MutationHookOptions, useMutation } from "@apollo/client";

// Apollo
import mutationGQL from "../../../mutation/catalog/createCounterBid.graphql";
import {
  CreateCounterBidMutation,
  CreateCounterBidMutationVariables,
} from "@whoppah/apollo/schema";

/**
 * Hook for creating a counter bid as a seller.
 * Note: Sellers always create counter bids, while buyers create bids.
 * @param options - Hook typing options.
 * @returns Mutation tuple, with executable calls.
 */
export const useCreateCounterBid = (
  options?: MutationHookOptions<
    CreateCounterBidMutation,
    CreateCounterBidMutationVariables
  >
) => {
  return useMutation(mutationGQL, options);
};
